export default __webpack_public_path__ + "static/media/pause.d4c80d88.svg";